import React, { memo, useCallback, useEffect, useState } from 'react';
import { WithErrorHandler } from 'newcar-ui/output/cjs/components/WithErrorHandler';
import "newcar-ui/output/index.css";
import './index.scss';
import classNames from 'classnames';
import { tools } from 'newcar-ui/output/cjs/utils';


const tabs = [{
    name: '新车',
    type: 'newcar'
}, {
    name: '车展',
    type: 'chezhan'
}, {
    name: '地图',
    type: 'map'
}, {
    name: '趣味',
    type: 'fun'
}, {
    name: '更多',
    type: 'more'
}]

function NavBar(props) {
    // const tabs = useMemo(() => props.tabs, [props.tabs])
    const { currentBar, setCurrentNav } = props
    // const currentTab = useMemo(() => props.currentTab, [props.currentTab])
    // const [tabIndex, setTabIndex] = useState(currentTab)
    const [innerIndex, setInnerIndex] = useState(0)
    const onTabClick = useCallback((tab, index) => {
        setInnerIndex(index)
        tools.sendClickStatistics_wmda(337, {
            name: tab.name,
            actionType: '24biae-switch-map-click'
        })
        if (typeof props.onTabChange !== undefined) {
            props.onTabChange(tab, index)
        }
    }, [props, setCurrentNav])

    useEffect(() => {
        const index_ = currentBar.split('-')[0];
        setInnerIndex(index_)
    }, [currentBar])
    return (
        <div className='tab-wrap' id={props.elId}>
            <div className='tab-content'>
                {
                    tabs.map((item, index) => {
                        return (
                            <div key={`tab${index}`}
                                className={classNames('tab-item', { selected: index == innerIndex })}
                                onClick={() => onTabClick(item, index)}>
                                <img src={`//icon.xgo-img.com.cn/mtouch/24040919/${item.type}${index == innerIndex ? '-selected' : ''}.png`}></img>
                                {item.name}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default WithErrorHandler(memo(NavBar));
